export default {
  title: 'Activa las notificaciones para ofertas y novedades exclusivas',
  description:
    'Recibe actualizaciones de tu pedido en tiempo real. Sigue el estado de tu entrega. Promos y ventajas exclusivas.',
  buttons: {
    confirm: 'Activar',
    cancel: 'Ahora no',
  },
};
